import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "valueInput",
    "search",
    "list",
    "hidden",
    "searchContainer",
  ];

  connect() {
    this.originalList = Array.from(this.listTarget.children);
    document.addEventListener("click", this.closeOnClickOutside.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside.bind(this));
  }

  // Show search input when value input is clicked
  showSearch(event) {
    this.searchContainerTarget.classList.remove("hidden");
    this.listTarget.classList.remove("hidden");
    this.searchTarget.focus();
  }

  search(event) {
    const query = event.target.value.toLowerCase();
    const filteredItems = this.originalList.filter((item) => {
      return item.textContent.toLowerCase().includes(query);
    });

    this.listTarget.innerHTML = "";
    filteredItems.forEach((item) => this.listTarget.appendChild(item));

    this.toggleListVisibility(filteredItems.length > 0);
  }

  // when option is selected
  select(event) {
    const selectedValue = event.currentTarget.dataset.value;
    const selectedText = event.currentTarget.textContent.trim();

    this.valueInputTarget.value = selectedText;
    this.hiddenTarget.value = selectedValue;
    
    // Trigger change event for other controllers to listen to
    this.hiddenTarget.dispatchEvent(new Event('change', { bubbles: true }));
    
    this.searchContainerTarget.classList.add("hidden");
    this.toggleListVisibility(false);
  }

  toggleListVisibility(show) {
    this.listTarget.classList.toggle("hidden", !show);
  }

  // close when clicked on page
  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.searchContainerTarget.classList.add("hidden");
      this.toggleListVisibility(false);
    }
  }
}
